import { TextFieldModule } from '@angular/cdk/text-field';
import { Component, Input } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';

import { TiimeInputContainerModule } from 'tiime-material';

import { SmsForm } from '@forms/sms-form';

@Component({
  selector: 'app-sms-form',
  standalone: true,
  imports: [TiimeInputContainerModule, TextFieldModule, ReactiveFormsModule],
  templateUrl: './sms-form.component.html',
  styleUrls: ['./sms-form.component.scss']
})
export class SmsFormComponent {
  @Input({ required: true }) form: SmsForm;
}
